import { FC, ReactNode } from "react";
import { AuthProvider } from "./auth";

interface Props {
    children: ReactNode;
}

const ContextsProvider: FC<Props> = ({ children }) => {
    return <AuthProvider>{children}</AuthProvider>;
};

export default ContextsProvider;
